import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { UserService } from '@asambleas-services/user/user.service';

@Directive({ selector: '[role]' })
export class RoleAuthorizationDirective {

    // Miembro es level 5
    requiredLevel: number = 5

    @Input() set role(level: number) {
        this.requiredLevel = level;
    }

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private _userService: UserService
    ) {
        //console.log('Role Auth Directive Constructor')
    }

    ngOnInit() {
        this._userService.currentUser.subscribe(user => {
            //console.log(user)
            if (user && user._role) {
                if (Number(user._role.level) <= this.requiredLevel) {
                    this.viewContainer.createEmbeddedView(this.templateRef);
                } else {
                    this.viewContainer.clear();
                }
            } else {
                this.viewContainer.clear();
            }
        }, error => {
            this.viewContainer.clear();
            console.log(error)
        })
    }

}



// WEBPACK FOOTER //
// ./src/app/directives/role-authorization.directive.ts